export default __webpack_public_path__ + "images/0xcd94a87696fac69edae3a70fe5725307ae1c43f6.png";